module.exports = __webpack_public_path__ + "media/images/emblems/Wyssachen-coat_of_arms-a19de4513df01867f8d880d1b90c072a.svg";